import React from 'react';
import { FieldDefinition, RuleCondition, RuleOperator } from '../../types/highlights';
import { defaultOperatorFor, operatorMeta, operatorsByType } from '../../utils/rules';
interface ConditionFieldsProps {
  condition: RuleCondition;
  catalog: FieldDefinition[];
  byId: Map<string, FieldDefinition>;
  onChange: (patch: Partial<RuleCondition>) => void;
}
const selectClass = 'max-w-[170px] rounded border border-slate-200 bg-white px-1.5 py-1 text-[12px] font-medium text-slate-800 focus:border-[#0b5cab] focus:outline-none';
const inputClass = 'w-24 rounded border border-slate-200 bg-white px-1.5 py-1 text-[12px] text-slate-800 focus:border-[#0b5cab] focus:outline-none';

/** Inline "[field] [condition] [value]" editor shared by rules and tags. */
export function ConditionFields({
  condition,
  catalog,
  byId,
  onChange
}: ConditionFieldsProps) {
  const source = byId.get(condition.sourceFieldId);
  const meta = source ? operatorMeta(source.type, condition.operator) : undefined;
  const inputs = meta?.inputs ?? 0;
  return <>
      <select aria-label="Field to evaluate" value={condition.sourceFieldId} onChange={event => {
      const next = byId.get(event.target.value);
      onChange({
        sourceFieldId: event.target.value,
        operator: next ? defaultOperatorFor(next.type) : condition.operator,
        value: '',
        value2: undefined
      });
    }} className={selectClass} data-id="element-15" data-mp="1q3l7yb2nxmjp">
        {catalog.map(definition => <option key={definition.id} value={definition.id} data-id="element-16" data-mp="1c54um1aaoxsl">
            {definition.label}
          </option>)}
      </select>
      <select aria-label="Condition" value={condition.operator} onChange={event => onChange({
      operator: event.target.value as RuleOperator
    })} className={selectClass.replace('font-medium ', '')} data-id="element-17" data-mp="1h5stta8ogkxw">
        {(source ? operatorsByType[source.type] : []).map(option => <option key={option.value} value={option.value} data-id="element-18" data-mp="xfgex7es0adf">
            {option.label}
          </option>)}
      </select>
      {inputs >= 1 ? <input aria-label="Comparison value" value={condition.value ?? ''} placeholder={meta?.placeholder} onChange={event => onChange({
      value: event.target.value
    })} className={inputClass} data-id="element-19" data-mp="sfkefi5af12m" /> : null}
      {inputs === 2 ? <>
          <span data-id="element-20" data-mp="epgtqvm23ffa">and</span>
          <input aria-label="Second comparison value" value={condition.value2 ?? ''} placeholder={meta?.placeholder} onChange={event => onChange({
        value2: event.target.value
      })} className={inputClass} data-id="element-21" data-mp="emkwl9i18urw" />
        </> : null}
    </>;
}